// Auto-generated by flatten_images.py
import armCircling from 'url:./arm-circling.png';
import arnoldPress from 'url:./arnold-press.png';
import arnoldPressTempo from 'url:./arnold-press-tempo.png';
import backwardLunge from 'url:./backward-lunge.png';
import barbellBackSquat from 'url:./barbell-back-squat.png';
import barbellBackSquatDecline from 'url:./barbell-back-squat-decline.png';
import barbellRow from 'url:./barbell-row.png';
import benchPress from 'url:./bench-press.png';
import benchPressDecline from 'url:./bench-press-decline.png';
import bicepCurl from 'url:./bicep-curl.png';
import birdDog from 'url:./bird-dog.png';
import birdDogCrunch from 'url:./bird-dog-crunch.png';
import bulgarianSplitSquat from 'url:./bulgarian-split-squat.png';
import bulgarianSplitSquatPaused from 'url:./bulgarian-split-squat-paused.png';
import burpees from 'url:./burpees.png';
import calfRaises from 'url:./calf-raises.png';
import cycling from 'url:./cycling.png';
import deadBug from 'url:./dead-bug.png';
import deadlift from 'url:./deadlift.png';
import deadliftResistanceBand from 'url:./deadlift-resistance-band.png';
import declineBenchPressTempo from 'url:./decline-bench-press-tempo.png';
import dips from 'url:./dips.png';
import donkeyKickBack from 'url:./donkey-kick-back.png';
import dumbbellBenchPress from 'url:./dumbbell-bench-press.png';
import dumbbellBenchPressPaused from 'url:./dumbbell-bench-press-paused.png';
import dumbbellLateralRaise from 'url:./dumbbell-lateral-raise.png';
import dumbbellRow from 'url:./dumbbell-row.png';
import frontRaise from 'url:./front-raise.png';
import frontSquat from 'url:./front-squat.png';
import frontSquatResistanceBand from 'url:./front-squat-resistance-band.png';
import gluteBridge from 'url:./glute-bridge.png';
import gluteBridgeSingleLeg from 'url:./glute-bridge-single-leg.png';
import gobletSquat from 'url:./goblet-squat.png';
import gobletSquatTempo from 'url:./goblet-squat-tempo.png';
import hackSquat from 'url:./hack-squat.png';
import hackSquatDecline from 'url:./hack-squat-decline.png';
import hammerCurl from 'url:./hammer-curl.png';
import hamstringCurl from 'url:./hamstring-curl.png';
import hangingLegRaise from 'url:./hanging-leg-raise.png';
import heelFlicks from 'url:./heel-flicks.png';
import highKnees from 'url:./high-knees.png';
import hipThrust from 'url:./hip-thrust.png';
import hipThrustPaused from 'url:./hip-thrust-paused.png';
import inclineBenchPress from 'url:./incline-bench-press.png';
import inclineBenchPressResistanceBand from 'url:./incline-bench-press-resistance-band.png';
import inclinePushUp from 'url:./incline-push-up.png';
import inclinePushUpIncline from 'url:./incline-push-up-incline.png';
import jabs from 'url:./jabs.png';
import jumpRope from 'url:./jump-rope.png';
import jumpingJacks from 'url:./jumping-jacks.png';
import kettlebellSwing from 'url:./kettlebell-swing.png';
import kneeToElbow from 'url:./knee-to-elbow.png';
import latPulldown from 'url:./lat-pulldown.png';
import lateralRaise from 'url:./lateral-raise.png';
import legExtension from 'url:./leg-extension.png';
import legPressIncline from 'url:./leg-press-incline.png';
import maleWoodCutterLeftToRight from 'url:./male-wood-cutter-left-to-right.png';
import maleWoodCutterRightToLeft from 'url:./male-wood-cutter-right-to-left.png';
import mountainClimbers from 'url:./mountain-climbers.png';
import overheadTricepExtension from 'url:./overhead-tricep-extension.png';
import plank from 'url:./plank.png';
import preacherCurl from 'url:./preacher-curl.png';
import pressUp from 'url:./press-up.png';
import pullUp from 'url:./pull-up.png';
import pushPress from 'url:./push-press.png';
import pushPressPaused from 'url:./push-press-paused.png';
import pushUp from 'url:./push-up.png';
import pushUpSingleLeg from 'url:./push-up-single-leg.png';
import rearDeltFly from 'url:./rear-delt-fly.png';
import romanianDeadlift from 'url:./romanian-deadlift.png';
import romanianDeadliftTempo from 'url:./romanian-deadlift-tempo.png';
import rowing from 'url:./rowing.png';
import russianTwist from 'url:./russian-twist.png';
import seatedCableRow from 'url:./seated-cable-row.png';
import shoulderPress from 'url:./shoulder-press.png';
import sideLunge from 'url:./side-lunge.png';
import sidePlank from 'url:./side-plank.png';
import sitUp from 'url:./sit-up.png';
import skullCrushers from 'url:./skull-crushers.png';
import squat from 'url:./squat.png';
import squatJumps from 'url:./squat-jumps.png';
import standingKickBack from 'url:./standing-kick-back.png';
import sumoSquat from 'url:./sumo-squat.png';
import tricepDipsBench from 'url:./tricep-dips-bench.png';
import tricepPushdown from 'url:./tricep-pushdown.png';
import upperCut from 'url:./upper-cut.png';
import walkingLunges from 'url:./walking-lunges.png';
import walkingLungesSingleLeg from 'url:./walking-lunges-single-leg.png';
import wallSit from 'url:./wall-sit.png';
import woodCutter from 'url:./wood-cutter.png';
import woodCutterLefttoRight from 'url:./wood-cutter-leftto-right.png';
import woodCutterRighttoLeft from 'url:./wood-cutter-rightto-left.png';

export const exerciseImages: Record<string, string> = {
  'arm-circling': armCircling,
  'arnold-press': arnoldPress,
  'arnold-press-tempo': arnoldPressTempo,
  'backward-lunge': backwardLunge,
  'barbell-back-squat': barbellBackSquat,
  'barbell-back-squat-decline': barbellBackSquatDecline,
  'barbell-row': barbellRow,
  'bench-press': benchPress,
  'bench-press-decline': benchPressDecline,
  'bicep-curl': bicepCurl,
  'bird-dog': birdDog,
  'bird-dog-crunch': birdDogCrunch,
  'bulgarian-split-squat': bulgarianSplitSquat,
  'bulgarian-split-squat-paused': bulgarianSplitSquatPaused,
  burpees: burpees,
  'calf-raises': calfRaises,
  cycling: cycling,
  'dead-bug': deadBug,
  deadlift: deadlift,
  'deadlift-resistance-band': deadliftResistanceBand,
  'decline-bench-press-tempo': declineBenchPressTempo,
  dips: dips,
  'donkey-kick-back': donkeyKickBack,
  'dumbbell-bench-press': dumbbellBenchPress,
  'dumbbell-bench-press-paused': dumbbellBenchPressPaused,
  'dumbbell-lateral-raise': dumbbellLateralRaise,
  'dumbbell-row': dumbbellRow,
  'front-raise': frontRaise,
  'front-squat': frontSquat,
  'front-squat-resistance-band': frontSquatResistanceBand,
  'glute-bridge': gluteBridge,
  'glute-bridge-single-leg': gluteBridgeSingleLeg,
  'goblet-squat': gobletSquat,
  'goblet-squat-tempo': gobletSquatTempo,
  'hack-squat': hackSquat,
  'hack-squat-decline': hackSquatDecline,
  'hammer-curl': hammerCurl,
  'hamstring-curl': hamstringCurl,
  'hanging-leg-raise': hangingLegRaise,
  'heel-flicks': heelFlicks,
  'high-knees': highKnees,
  'hip-thrust': hipThrust,
  'hip-thrust-paused': hipThrustPaused,
  'incline-bench-press': inclineBenchPress,
  'incline-bench-press-resistance-band': inclineBenchPressResistanceBand,
  'incline-push-up': inclinePushUp,
  'incline-push-up-incline': inclinePushUpIncline,
  jabs: jabs,
  'jump-rope': jumpRope,
  'jumping-jacks': jumpingJacks,
  'kettlebell-swing': kettlebellSwing,
  'knee-to-elbow': kneeToElbow,
  'lat-pulldown': latPulldown,
  'lateral-raise': lateralRaise,
  'leg-extension': legExtension,
  'leg-press-incline': legPressIncline,
  'male-wood-cutter-left-to-right': maleWoodCutterLeftToRight,
  'male-wood-cutter-right-to-left': maleWoodCutterRightToLeft,
  'mountain-climbers': mountainClimbers,
  'overhead-tricep-extension': overheadTricepExtension,
  plank: plank,
  'preacher-curl': preacherCurl,
  'press-up': pressUp,
  'pull-up': pullUp,
  'push-press': pushPress,
  'push-press-paused': pushPressPaused,
  'push-up': pushUp,
  'push-up-single-leg': pushUpSingleLeg,
  'rear-delt-fly': rearDeltFly,
  'romanian-deadlift': romanianDeadlift,
  'romanian-deadlift-tempo': romanianDeadliftTempo,
  rowing: rowing,
  'russian-twist': russianTwist,
  'seated-cable-row': seatedCableRow,
  'shoulder-press': shoulderPress,
  'side-lunge': sideLunge,
  'side-plank': sidePlank,
  'sit-up': sitUp,
  'skull-crushers': skullCrushers,
  squat: squat,
  'squat-jumps': squatJumps,
  'standing-kick-back': standingKickBack,
  'sumo-squat': sumoSquat,
  'tricep-dips-bench': tricepDipsBench,
  'tricep-pushdown': tricepPushdown,
  'upper-cut': upperCut,
  'walking-lunges': walkingLunges,
  'walking-lunges-single-leg': walkingLungesSingleLeg,
  'wall-sit': wallSit,
  'wood-cutter': woodCutter,
  'wood-cutter-leftto-right': woodCutterLefttoRight,
  'wood-cutter-rightto-left': woodCutterRighttoLeft,
};
